export const ORDER_PREVIEW = `/order/order-preview`;
export const ORDER_CHECKOUT = `/order/checkout`;
export const ORDER_LIST = `/order/list`;
export const ORDER_BY_ID = `/order/details/`;
export const ORDER_PAYMENT = `/payment/save-status/`;
export const GET_ORDER = `/payment/razor/order/`;
export const MAIL_INVOICE = `/order/mail-invoice`;
export const INVOICE_PREVIEW = `/order/order-preview`;

